import {
    Container,
    Sprite,
    Texture,
} from 'pixi.js';
import { Button, fonts, FocusManager, StyledBitmapText } from '../../ui';
import { GAMEPLAY } from '../../constants';
import { LoadContext } from '../../utils';

export class NextLevelDialog extends Container
{
    private bg: Sprite;
    private title: StyledBitmapText;
    private question: StyledBitmapText;
    public nextLevel: Button;
    public nextLevelBatCount: number;
    public sameLevel: Button;
    public sameLevelBatCount: number;
    public prevLevel: Button;
    public prevLevelBatCount: number;

    public static preload()
    {
        const loader = LoadContext.current;
        loader.add('ResultAtlas', './assets/result/ResultAtlas{size}.json');
        Button.preload();
    }

    constructor(levelNum:number, success:boolean, remaining:number)
    {
        super();

        const loader = LoadContext.current;
        const spritesheet = loader.getSpritesheet('ResultAtlas');

        // BG size: 1438x807
        this.bg = new Sprite(spritesheet.textures['sqwak']);
        this.addChild(this.bg);

        const titleText = success ? `You crashed a Level ${levelNum} cave!` : 'You ran out of battery!';
        this.title = new StyledBitmapText(titleText, {tint: 0xffffff, fontSize: 58, fontName: 'Nunito'});
        this.title.anchor.set(0.5);
        this.title.position.set(1438/2, 184);
        this.addChild(this.title);

        this.question = new StyledBitmapText('What would you like to do next?', {tint: 0xffffff, fontSize: 36, fontName: 'Nunito'});
        this.question.anchor.set(0.5);
        this.question.position.set(1438/2, 297);
        this.addChild(this.question);

        const nextLevelIndex = levelNum + 1;
        const prevLevelIndex = levelNum - 1;
        const buttonTex = spritesheet.textures['btn_level'] as Texture;

        if (nextLevelIndex < GAMEPLAY.LEVELS.length && success)
        {
            this.nextLevelBatCount = Math.min(GAMEPLAY.LEVELS[nextLevelIndex].BAT_REWARD, remaining);
            this.nextLevel = new Button(buttonTex, {
                content: `Try the next level - rescue ${this.nextLevelBatCount} Bats`,
                style: fonts.SettingsIntroButton,
            });
            this.nextLevel.position.set(1438/2, 404);
            this.addChild(this.nextLevel);
            this.nextLevel.on('pointertap', () => this.buttonPress(1));
        }

        this.sameLevelBatCount = Math.min(GAMEPLAY.LEVELS[levelNum].BAT_REWARD, remaining);
        this.sameLevel = new Button(buttonTex, {
            content: `Replay the same level - rescue ${this.sameLevelBatCount} Bats`,
            style: fonts.SettingsIntroButton,
        });
        this.sameLevel.position.set(1438/2, this.nextLevel ? 521 : 404);
        this.addChild(this.sameLevel);
        this.sameLevel.on('pointertap', () => this.buttonPress(0));

        if (prevLevelIndex > 0)
        {
            this.prevLevelBatCount = Math.min(GAMEPLAY.LEVELS[prevLevelIndex].BAT_REWARD, remaining);
            this.prevLevel = new Button(buttonTex, {
                content: `Go back a level - rescue ${this.prevLevelBatCount} Bats`,
                style: fonts.SettingsIntroButton,
            });
            this.prevLevel.position.set(1438/2, this.nextLevel ? 633 : 521);
            this.addChild(this.prevLevel);

            this.prevLevel.on('pointertap', () => this.buttonPress(-1));
        }

        this.visible = false;
    }

    public open()
    {
        this.visible = true;
    }

    public get focus() { return [this.nextLevel, this.sameLevel, this.prevLevel].filter(b => !!b); }

    private buttonPress(levelChange:number)
    {
        if (this.nextLevel) {
            this.nextLevel.enabled = false;
            this.nextLevel.highlight = false;
        }
        this.sameLevel.enabled = false;
        this.sameLevel.highlight = false;
        if (this.prevLevel) this.prevLevel.enabled = false;
        this.emit('level', levelChange);
    }

    public highlight()
    {
        if (this.nextLevel)
        {
            this.nextLevel.highlight = true;
        }
        else
        {
            this.sameLevel.highlight = true;
        }
    }

    public destroy()
    {
        if (this.visible)
        {
            FocusManager.instance.popContext();
        }
        super.destroy({children: true});
    }
}